import React from "react";
import { Form } from "antd";
import IntegerInput from "../IntergerInput"; // adjust path if needed

const FormItemIntegerInput = ({
  label,
  name,
  rules = [],
  placeholder = "Enter value",
  maxLength,
  disabled = false,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
    >
      <IntegerInput
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default FormItemIntegerInput;